import { FC } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { RouteComponentProps } from 'react-router-dom'
import { IonIcon, IonLabel } from '@ionic/react'
import cx from 'classnames'
import { chevronForward } from 'ionicons/icons'

import { appConfig } from '@/services/config'
import { Routes } from '@/router/routes'

interface ExistingAccountLoginProps {
  history: RouteComponentProps['history']
}

const ExistingAccountLogin: FC<ExistingAccountLoginProps> = ({ history }) => {
  const { t } = useTranslation('common')

  return (
    <IonLabel
      className={cx('cursor-pointer text-sm min-[400px]:text-base', {
        'mt-auto': appConfig.ssoVisible,
      })}
      onClick={() => history.push(Routes.AUTH_LOGIN)}
    >
      <Trans
        t={t}
        i18nKey={'registration.signUpOptions.existingAccountLogIn'}
        components={{ underline: <span className="border-b-[0.0625rem]" /> }}
      />
      <IonIcon
        className="text-primary ml-1 align-middle text-sm"
        icon={chevronForward}
      />
    </IonLabel>
  )
}

export default ExistingAccountLogin
